<main class="term-container" aria-labelledby="terms-title" role="main">
  <h1 id="terms-title" class="visually-hidden">{{'TermsofService' | translate}}</h1>
  <h3 class="term--subtitle" itemprop="name">{{'TermLastUpdated'| translate}}</h3>
  <div class="term-list" role="list">

    @for (item of termModel.items; track item.order) {
    <article class="term-card" role="listitem" itemscope itemtype="https://schema.org/LegalService">
      <h2 class="term-title" itemprop="name">{{item.order}}. {{ item.title }}</h2>
      <div class="term-content" itemprop="description" [innerHTML]="item.content"></div>
    </article>

    }
  </div>

  <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Terms and Conditions",
      "hasPart": [
        {{ termModel.items.map(i => '{"@type":"CreativeWork","position":'+(i.order)+',"name":"'+(i.title)+'"}') .join(', ') }}
      ]
    }
    </script>
</main>